// src/components/guards/LegalGate.js
import React, { useEffect } from 'react';
import { useProfile } from '../../context/ProfileContext';
import LegalMigrationModal from './LegalMigrationModal';

const LegalGate = () => {
  const { activeProfile, isLoading } = useProfile();

  useEffect(() => {
    
  }, [activeProfile, isLoading]);

  if (isLoading || !activeProfile) return null;

  const isArtist = activeProfile.type === 'artist';
  const needsMigration = activeProfile.legalRequirementStatus === 'REQUIRED';

  if (isArtist && needsMigration) {
    console.warn("DEBUG_GATE: Blocking access for legacy artist:", activeProfile.artistName);
    return <LegalMigrationModal artistData={activeProfile} />;
  }

  return null;
};

export default LegalGate;